import { systemConfig } from '@/config/systemConfig';
import { Inspection } from '@/types/Inspection.type';
import { Template } from '@/types/Template.type';
import { resolveConductTemplateId } from '@/utils/conduct-template.util';
import { getTemplate } from '@/utils/inspection.utils';
import React from 'react';

export const useTemplate = (inspection: Inspection | undefined) => {
  const [inspectionStructure, setInspectionStructure] = React.useState<Template>();
  const templateId = resolveConductTemplateId({
    templateDiscriminator: inspection?.template?.template,
    inspectionLevelCode: inspection?.inspectionLevel?.code,
    controlPointName: inspection?.controlPoint?.name,
    tenantId: systemConfig.tenantId,
  });
  const version = inspection?.template?.version;

  React.useEffect(() => {
    function loadInspectionStructure() {
      if (templateId) {
        setInspectionStructure(getTemplate(templateId, version));
      }
    }
    loadInspectionStructure();
  }, [templateId, version]);

  return inspectionStructure;
};
